export const download_chart = (id:string, name:string, has_legend_bottom?: boolean) =>{

    console.log(document.getElementsByClassName("apexcharts-legend"));
    // Update charts options before downloading (to have a different result between the chart displayed on the UI and the downloaded image)
    // ApexCharts.exec(id, 'updateOptions', {
    //     chart: {
    //         height: 600,
    //         type: "pie"
    //     },
    //     legend: has_legend_bottom ? { } : {
    //         position: 'bottom',
    //         // verticalAlign: 'middle',
    //         // align: 'center',
    //         alignContent: "baseline",
    //         height: 300
    //     }
    //   }, false, true);

    ApexCharts.exec(id, "dataURI").then((data:any) => {
        if(data?.imgURI){
            const link = document.createElement('a');
            link.href = data.imgURI;
            link.setAttribute('download', `${name}.png`);
            document.body.appendChild(link);
            link.click();
            link.parentNode?.removeChild(link);
        }
        else{
            console.error(`download_chart error`);
        }
    });
    
    // Update charts options again to retrieve previous charts display
    // if(!has_legend_bottom){
    //     ApexCharts.exec(id, 'updateOptions', {
    //         legend: {
    //           position: 'right'
    //         }
    //       }, false, true);
    // }
}